module.exports = __webpack_public_path__ + "img/Photo_3___Fourth_Canal_2006_31_2.0f7ab59b.jpg";